(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doxxa-cinematic-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('doxxa-cinematic-story')) {
    customElements.define('doxxa-cinematic-story', class extends HTMLElement {
      connectedCallback() {
        this.hold = Math.max(2500, (Number(this.dataset.hold) || 7000) / 2);
        this.panels = [...this.querySelectorAll('.dg-cinema__panel')];
        this.mobileScenes = [...this.querySelectorAll('[data-mobile-scene]')];
        this.caption = this.querySelector('[data-caption]');
        this.openingCaption = this.caption ? this.caption.textContent : '';
        this.timers = [];
        this.running = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mobileView = window.matchMedia('(max-width: 749px)').matches;

        if (this.reducedMotion) return;

        if (!('IntersectionObserver' in window)) {
          this.start();
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.start();
          } else {
            this.stop();
          }
        }, { threshold: 0.05 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
      }

      schedule(callback, delay) {
        const timer = window.setTimeout(callback, delay);
        this.timers.push(timer);
      }

      start() {
        if (this.running) return;
        this.running = true;
        this.resetOpening();
        this.schedule(() => this.classList.add('is-split'), 450);
        this.schedule(() => this.showScene(1), 1100);
      }

      stop() {
        this.running = false;
        this.timers.forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      resetOpening() {
        this.classList.remove('is-split', 'is-story', 'is-resetting');
        if (!this.mobileView) {
          this.panels.forEach((panel) => {
            panel.querySelectorAll('.dg-cinema__scene').forEach((scene) => scene.classList.remove('is-active'));
          });
        }
        this.mobileScenes.forEach((scene) => scene.classList.remove('is-active'));
        this.setCaption(this.openingCaption);
      }

      showScene(index) {
        if (!this.running) return;
        this.classList.add('is-story');

        this.mobileScenes.forEach((scene) => {
          scene.classList.toggle('is-active', Number(scene.dataset.mobileScene) === index);
        });

        if (!this.mobileView) {
          this.panels.forEach((panel, panelIndex) => {
            this.schedule(() => {
              panel.querySelectorAll('.dg-cinema__scene').forEach((scene) => {
                scene.classList.toggle('is-active', Number(scene.dataset.scene) === index);
              });
            }, panelIndex * 140);
          });
        }

        const caption = this.querySelector('[data-caption-value="' + index + '"]');
        this.setCaption(caption ? caption.textContent : '');

        if (index < 3) {
          this.schedule(() => this.showScene(index + 1), this.hold);
        } else {
          this.schedule(() => this.restart(), this.hold);
        }
      }

      restart() {
        if (!this.running) return;
        this.classList.add('is-resetting');
        this.schedule(() => {
          this.resetOpening();
          this.schedule(() => this.classList.remove('is-resetting'), 80);
          this.schedule(() => this.classList.add('is-split'), 530);
          this.schedule(() => this.showScene(1), 1180);
        }, 650);
      }

      setCaption(value) {
        if (!this.caption || this.caption.textContent === value) return;
        this.caption.classList.add('is-changing');
        this.schedule(() => {
          this.caption.textContent = value;
          this.caption.classList.remove('is-changing');
        }, 300);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
